<div class="trigger" (click)="toggle()">
    <ng-content select="[dropdown-trigger]"></ng-content>
</div>
<div #dropdownView class="dropdown-view" *ngIf="showView">
    <ng-content select="div[dropdown-view]"></ng-content>
</div>
<div class="mask" *ngIf="showView" (click)="toggle()">
</div>
